export const formatLikeCounter =(num)=> {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + "M"; // Converts to millions
    } else if (num >= 1000) {
      return (num / 1000).toFixed(1) + "K"; // Converts to thousands
    } else {
      return num.toString(); // Returns the number as is
    }
  }